<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For Sybil</i>, without whose absence</span></p>
<p class="ded1"><span>this book would not have come about</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?16f5d9ea